"use strict";
// tslint:disable
// eslint-disable
/**
 * API Key Management API
 * API for CRUDing API Keys
 *
 * The version of the OpenAPI document: 1.0.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
function ErrorResponseDeletedFromJSON(json) {
    return ErrorResponseDeletedFromJSONTyped(json, false);
}
exports.ErrorResponseDeletedFromJSON = ErrorResponseDeletedFromJSON;
function ErrorResponseDeletedFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ErrorResponseDeletedFromJSONTyped = ErrorResponseDeletedFromJSONTyped;
function ErrorResponseDeletedToJSON(value) {
    return value;
}
exports.ErrorResponseDeletedToJSON = ErrorResponseDeletedToJSON;
